// extracted by mini-css-extract-plugin
export var quantityInput = "_ib-0";